import { createContext, useContext } from 'react';

export interface BlueprintContextProps {
  showPolicies: boolean;
  setShowPolicies(val: boolean);
  showExceptions: boolean;
  setShowExceptions(val: boolean);
}

export const BlueprintContext = createContext<BlueprintContextProps>({
  showPolicies: false,
  setShowPolicies() {},
  showExceptions: false,
  setShowExceptions() {},
});

export const BlueprintContextProvider = BlueprintContext.Provider;

export const useBlueprintsContext = () => useContext(BlueprintContext);
